import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { CurrentUserService } from '../services/current-user.service';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  return inject(CurrentUserService).hasRole(route?.data?.['roles'] ?? []);
};
